import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { R } from '@core/utils/r';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { ProposalTemplateResponse } from '@business/entities/proposal';
import { tap } from 'rxjs/operators';
import { CourseStepResponse } from '@business/entities/course';

export class CourseBuilderPageBloc extends BaseBloc {
  private readonly courseBloc = resolve(Blocs.course);
  constructor(private readonly lessonId: string) {
    super();
  }

  readonly loading = new LoadingState();

  readonly pageVisibility$ = new BehaviorSubject<{ index: number; height: number }[]>([]);
  readonly currentSection$ = new BehaviorSubject(-1);

  readonly lesson$ = new BehaviorSubject<CourseStepResponse | null>(null);

  onInit() {
    if (this.lessonId == '0') {
      return of(null).pipe(this.loading.run());
    }
    return this.courseBloc.getStep(this.lessonId).pipe(
      tap(item => {
        this.lesson$.next(item);
      }),
      this.loading.run(),
    );
  }

  onVisibilityChange(isVisible: boolean, index: number, height: number) {
    if (isVisible) {
      this.pageVisibility$.next([...this.pageVisibility$.value.filter(item => item.index !== index), { index, height }]);
    } else {
      this.pageVisibility$.next(this.pageVisibility$.value.filter(item => item.index !== index));
    }
    this.setCurrentPage();
  }

  setCurrentPage = R.debounce(() => {
    const currentValue = this.pageVisibility$.value;
    if (currentValue.length > 0) {
      const max = R.last(R.sortBy(currentValue, item => item.height));
      this.currentSection$.next(max!.index);
    }
  }, 300);

  updateFormData = this.courseBloc.updateFormData;
}
